<script lang="ts" setup>
import { computed } from "vue";
import { useDynamicFavicon } from "~/composables/useDynamicFavicon";
import { getGameIcon } from "~/utils/image.utils";

const appStateStore = useAppStateStore();
const merchantLogoUrl = computed(() => {
  if (!appStateStore.currentMerchant) return null;
  return getGameIcon(appStateStore.currentMerchant);
});

useDynamicFavicon(merchantLogoUrl);
</script>

<template>
  <div
    class="relative min-h-screen h-full flex flex-col items-center overflow-x-hidden">
    <Header />

    <main
      class="mt-[190px] grow mx-auto max-w-screen px-2 sm:px-6 md:px-8 lg:max-w-(--breakpoint-2xl) lg:px-24 w-screen">
      <slot />
    </main>
    <LazyCommonChatWidget />

    <TheFooter />
  </div>
</template>
